import { render, staticRenderFns } from "./CloneDetail.vue?vue&type=template&id=68e8a744&scoped=true"
import script from "./CloneDetail.vue?vue&type=script&lang=js"
export * from "./CloneDetail.vue?vue&type=script&lang=js"
import style0 from "./CloneDetail.vue?vue&type=style&index=0&id=68e8a744&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e8a744",
  null
  
)

export default component.exports